import { API_MESSAGE } from "@const/api-messages.const";
import { ApiResponse } from "@interfaces/dto/swr.dto";

import { api, fetcher } from "@api/_base";
import useSWR from "swr";
import { ProductDisplayConfig } from "@interfaces/components/product-filters.interface";
import { UpsellsProductsResponse } from "@interfaces/dto/products.dto";
import { getFilterQuery, getPageQuery } from "./_utils";
import { composeQueryParams } from "@utils/query.utils";


export const customerViewProduct = async ({
    productId,
    customerId
}: {
    productId: number,
    customerId: number
}): Promise<ApiResponse> => {
  try {
    const resp = await api.post(`/nextapi/customerviewproduct`, {
        product_id: productId,
        customer_id: customerId
    });
    return { isOk: true, message: "", data: resp.data };
  } catch (error: any) {
    const errorMessage: string =
      error.response.data.message ?? API_MESSAGE.INTERNAL_ERROR;
    return { isOk: false, message: errorMessage };
  }
}

export const useCustomerViewedProduct = ({
  customerId,
}: {
  customerId: string | undefined;
}): any => {
  let query: string | undefined = undefined;
  if (customerId) {
    query = customerId;
  }

  const { data, error, mutate } = useSWR(
    query ? `/nextapi/customerviewproduct/customer/${query}/view/recentview` : undefined,
    fetcher
  );

  return {
    data: data ? data : undefined,
    isLoading: !error && !data,
    error: error,
    mutate: mutate,
  };
};


export const useRecentViewProducts = ({
  entityId,
  neqProductId,
  productDisplayConfig,
}: {
  entityId: string | undefined;
  neqProductId: string | undefined;
  productDisplayConfig: ProductDisplayConfig;
}): UpsellsProductsResponse => {
  let query: string | undefined = undefined;
  // require categoryId
  if (entityId) {
    const queryCat = getFilterQuery({
      field: "entity_id",
      value: entityId,
      cond: "in",
      layer: 0,
    });
    // [page]
    const { pageSize, currentPage, sortBy } = productDisplayConfig;
    const queryPage = getPageQuery({
      pageSize: pageSize,
      currentPage: currentPage,
      sortBy: sortBy
    });

    //Not include current view product
    const queryNeq = `searchCriteria[filterGroups][0][filters][1][field]=entity_id&searchCriteria[filterGroups][0][filters][1][value]=${neqProductId}&searchCriteria[filterGroups][0][filters][1][conditionType]=neq`

    query = composeQueryParams([queryCat, queryPage, queryNeq]);
  }
  // console.log(query)

  const { data, error, mutate } = useSWR(
    query ? `/nextapi/products?${query}` : undefined,
    fetcher, {
      revalidateOnFocus: true
    }
  );

  return {
    data: data ? data : undefined,
    isLoading: !error && !data,
    error: error,
    mutate: mutate,
  };
};